import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "px-6 pt-2 pb-1 text-xs uppercase tracking-wide text-gray-500",
  role: "presentation"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  class: "py-2 font-medium",
  role: "menuitem"
}
const _hoisted_4 = {
  style: {"grid-template-columns":"2em auto"},
  class: "grid gap-2"
}
const _hoisted_5 = { class: "grid content-center" }
const _hoisted_6 = { class: "h-full text-gray-800 inline-flex items-center" }
const _hoisted_7 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_DropDown = _resolveComponent("DropDown")!

  return (_ctx.hasVisibleItems)
    ? (_openBlock(), _createBlock(_component_DropDown, {
        key: 0,
        expand: _ctx.expandDropdown,
        "onUpdate:expand": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.expandDropdown) = $event)),
        "dropdown-class": "mt-1 w-60"
      }, {
        "dropdown-content": _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleGroups, (group) => {
            return (_openBlock(), _createElementBlock("div", {
              key: group.key,
              class: "py-1"
            }, [
              _createElementVNode("div", _hoisted_1, _toDisplayString(group.label), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: item.key,
                  class: "text-left w-full px-6 py-2 hover:bg-gray-100 cursor-pointer",
                  onClick: ($event: any) => (_ctx.onItemClicked(item)),
                  onKeydown: _cache[0] || (_cache[0] = _withKeys(($event: any) => (_ctx.expandDropdown = false), ["esc"]))
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_Icon, {
                          src: item.icon
                        }, null, 8, ["src"])
                      ]),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(item.label), 1)
                    ])
                  ])
                ], 40, _hoisted_2))
              }), 128))
            ]))
          }), 128))
        ]),
        default: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            class: "h-full grid content-center cursor-pointer",
            "aria-label": _ctx.$t('layouts.dashboard.topBar.gearMenu.header'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.expandDropdown = !_ctx.expandDropdown))
          }, [
            _createVNode(_component_Icon, {
              src: _ctx.gearIcon,
              class: "filter brightness-0 invert w-7 h-7"
            }, null, 8, ["src"])
          ], 8, _hoisted_7)
        ]),
        _: 1
      }, 8, ["expand"]))
    : _createCommentVNode("", true)
}